import { createAjaxAction } from "../../../Common/_actions/AjaxAction";
import { StoreProductListPayload } from "../../_stores/Store/StoreProductListStore";
import { UserProductDesignPayload } from "../../_stores/UserProductDesignStore";
import { EditManyProductDesigns } from "../ProductDesignStoreActions";
import { EditStoreProductList, InvalidateStoreProducts } from "./StoreProductStoreActions";

export interface BatchStoreProductSelection {
  ids: number[]
  selectAll?: boolean
  excludeIds?: number[]
  filters?: {
    search?: string[]
    state?: string[]
    productTypes?: string[]
  }
}

export enum StoreProductActionType {
  FetchStoreProducts = 'STORE_PRODUCT_FETCH_STORE_PRODUCTS',
  DeleteStoreProduct = 'STORE_PRODUCT_DELETE_STORE_PRODUCT',
  BatchDeleteStoreProducts = 'STORE_PRODUCT_BATCH_DELETE_STORE_PRODUCTS',
  BatchIgnoreStoreProducts = 'STORE_PRODUCT_BATCH_IGNORE_STORE_PRODUCTS',
  BatchUnignoreStoreProducts = 'STORE_PRODUCT_BATCH_UNIGNORE_STORE_PRODUCTS',
  BatchUnsyncStoreProducts = 'STORE_PRODUCT_BATCH_UNSYNC_STORE_PRODUCTS',
}

export const FetchStoreProducts = (
  storeType: string, 
  listId: string, 
  data:FormData
) => createAjaxAction<{storeProducts: StoreProductListPayload, designs: UserProductDesignPayload[]}>(StoreProductActionType.FetchStoreProducts, {
	url: 'ajax/api/user/stores/' + storeType + '/products?listId='+listId,
	method: "GET",
	data: data,
	limit: 150,
	abortPrevious: true,
	onSuccess: (response, dispatch) => {
    dispatch(EditStoreProductList(storeType, listId, response.data.storeProducts))
    dispatch(EditManyProductDesigns(response.data.designs))
	},
	onFailure: (response, dispatch) => {}
});

export const DeleteStoreProduct = (
  storeType: string,
  storeProductId: number,
) => {
  return createAjaxAction<{}>(StoreProductActionType.DeleteStoreProduct, {
    url: 'ajax/api/user/stores/' + storeType + '/products/'+String(storeProductId)+'/delete',
    method: 'POST',
    onSuccess: (response, dispatch) => {
      dispatch(InvalidateStoreProducts(storeType))
    },
  });
}

const appendBatchSelection = (data: FormData, selection: BatchStoreProductSelection) => {
  if (selection.selectAll) {
    data.append('select_all', '1');

    selection.excludeIds?.forEach((storeProductId) => {
      data.append('exclude_ids[]', String(storeProductId));
    });

    if (selection.filters?.search && selection.filters.search.length > 0) {
      data.append('search', selection.filters.search.join(','));
    }

    if (selection.filters?.state && selection.filters.state.length > 0) {
      data.append('state', selection.filters.state.join(','));
    }

    if (selection.filters?.productTypes && selection.filters.productTypes.length > 0) {
      data.append('productTypes', selection.filters.productTypes.join(','));
    }

    return;
  }

  selection.ids.forEach((storeProductId) => {
    data.append('ids[]', String(storeProductId));
  });
}

export const BatchDeleteStoreProducts = (
  storeType: string,
  selection: BatchStoreProductSelection,
) => {
  const data = new FormData();

  appendBatchSelection(data, selection);

  return createAjaxAction<{}>(StoreProductActionType.BatchDeleteStoreProducts, {
    url: 'ajax/api/user/stores/' + storeType + '/products/batch-delete',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(InvalidateStoreProducts(storeType))
    },
  });
}

export const BatchIgnoreStoreProducts = (
  storeType: string,
  selection: BatchStoreProductSelection,
) => {
  const data = new FormData();

  appendBatchSelection(data, selection);

  return createAjaxAction<{}>(StoreProductActionType.BatchIgnoreStoreProducts, {
    url: 'ajax/api/user/stores/' + storeType + '/products/batch-ignore',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(InvalidateStoreProducts(storeType))
    },
  });
}

export const BatchUnignoreStoreProducts = (
  storeType: string,
  selection: BatchStoreProductSelection,
) => {
  const data = new FormData();

  appendBatchSelection(data, selection);

  return createAjaxAction<{}>(StoreProductActionType.BatchUnignoreStoreProducts, {
    url: 'ajax/api/user/stores/' + storeType + '/products/batch-unignore',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(InvalidateStoreProducts(storeType))
    },
  });
}

export const BatchUnsyncStoreProducts = (
  storeType: string,
  selection: BatchStoreProductSelection,
) => {
  const data = new FormData();

  appendBatchSelection(data, selection);

  return createAjaxAction<{}>(StoreProductActionType.BatchUnsyncStoreProducts, {
    url: 'ajax/api/user/stores/' + storeType + '/products/batch-unsync',
    method: 'POST',
    data: data,
    onSuccess: (response, dispatch) => {
      dispatch(InvalidateStoreProducts(storeType))
    },
  });
}
